export default __webpack_public_path__ + "static/media/DataGovernance.5d6fcb84.svg";